/**
 * OA Hero Slider — Premium responsive slider
 * Door Online Actief (online-actief.nl)
 */
(() => {
  class OASlider {
    constructor(el) {
      this.el = el;
      this.slides = [...el.querySelectorAll('.oa-slider__slide')];
      this.dots = [...el.querySelectorAll('.oa-slider__dot')];
      this.prevBtn = el.querySelector('.oa-slider__nav--prev');
      this.nextBtn = el.querySelector('.oa-slider__nav--next');
      this.progressBar = el.querySelector('.oa-slider__progress-bar');
      this.current = 0;
      this.total = this.slides.length;
      this.autoplay = el.dataset.autoplay === 'true';
      this.interval = parseInt(el.dataset.interval, 10) || 5000;
      this.timer = null;
      this.isTransitioning = false;
      this.touchStartX = 0;
      this.touchEndX = 0;

      if (this.total < 2) {
        this.hideControls();
        return;
      }

      this.bind();
      if (this.autoplay) this.startAutoplay();
    }

    bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      /* Touch / Swipe */
      this.el.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
        this.pauseAutoplay();
      }, { passive: true });

      this.el.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
        if (this.autoplay) this.startAutoplay();
      }, { passive: true });

      /* Pause autoplay on hover */
      this.el.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.el.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      /* Keyboard */
      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      /* Visibility API — pause when tab is hidden */
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAutoplay();
        } else if (this.autoplay) {
          this.startAutoplay();
        }
      });
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.next();
        else this.prev();
      }
    }

    goTo(index) {
      if (this.isTransitioning || index === this.current) return;
      this.isTransitioning = true;

      const prev = this.slides[this.current];
      const next = this.slides[index];

      prev.classList.remove('is-active');
      prev.classList.add('is-exiting');

      next.classList.add('is-active');

      /* Update dots */
      this.dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });

      this.current = index;

      /* Reset progress bar */
      this.resetProgress();

      setTimeout(() => {
        prev.classList.remove('is-exiting');
        this.isTransitioning = false;
      }, 1000);
    }

    next() {
      this.goTo((this.current + 1) % this.total);
    }

    prev() {
      this.goTo((this.current - 1 + this.total) % this.total);
    }

    startAutoplay() {
      this.pauseAutoplay();
      this.resetProgress();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    pauseAutoplay() {
      clearInterval(this.timer);
      if (this.progressBar) {
        this.progressBar.classList.remove('is-running');
        this.progressBar.style.transitionDuration = '0s';
        this.progressBar.style.width = '0%';
      }
    }

    resetProgress() {
      if (!this.progressBar || !this.autoplay) return;
      this.progressBar.classList.remove('is-running');
      this.progressBar.style.transitionDuration = '0s';
      this.progressBar.style.width = '0%';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.progressBar.style.transitionDuration = this.interval + 'ms';
          this.progressBar.style.width = '100%';
          this.progressBar.classList.add('is-running');
        });
      });
    }

    hideControls() {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      const dotsWrap = this.el.querySelector('.oa-slider__dots');
      if (dotsWrap) dotsWrap.style.display = 'none';
      const progress = this.el.querySelector('.oa-slider__progress');
      if (progress) progress.style.display = 'none';
    }
  }

  function init() {
    document.querySelectorAll('.oa-slider').forEach(el => {
      if (!el._oaSlider) {
        el._oaSlider = new OASlider(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
